import CustomAreaPointData from "./data";

export default function customAreaPointDataFromJson(json) {
    return new CustomAreaPointData(
        json.latitude,
        json.longitude,
        json.position,
    )
}